import Box from '@mui/material/Box';
import aboutUs from '../aboutUsContent.json';

function AboutUsPage(){
  
  const h2textStyle={
    fontFamily: "Georgia",
    fontSize: 25,
    marginBottom: "40px",
    color: '#281404'
  }

  const h3textStyle={
    fontFamily: "Georgia",
    fontSize: 22,
    marginBottom: "40px",
    color: '#281404'
  }

  const textStyle={
    fontFamily: "Georgia",
    fontSize: 20,
    marginBottom: "40px",
    marginRight: "80px",
    color: '#281404'
  }

  const h5textStyle={
    fontFamily: "Georgia",
    fontSize: 20,
    fontWeight: 600,
    marginBottom: "40px",
    marginTop: "60px",
    color: '#281404'
  }

  return (
    <Box sx={{margin: "40px"}}>
      <h2 style={h2textStyle}>{aboutUs.title}</h2> 
      <h3 style={h3textStyle}>{aboutUs.legacy}</h3>
      <p style={textStyle}>{aboutUs.legacyBody}</p> 
      <h3 style={h3textStyle}>{aboutUs.tailoredSolution}</h3>
      <p style={textStyle}>{aboutUs.tailoredBody}</p>
      <p style={textStyle}>{aboutUs.p1}</p>
      <p style={textStyle}>{aboutUs.p2}</p>
      <p style={textStyle}>{aboutUs.p3}</p>
      <h3 style={h3textStyle}>{aboutUs.slogan2}</h3>
      <p style={textStyle}>{aboutUs.services}</p>
      <p style={textStyle}>{aboutUs.s1}</p>
      <p style={textStyle}>{aboutUs.s2}</p>
      <p style={textStyle}>{aboutUs.s3}</p>
      <p style={textStyle}>{aboutUs.s4}</p>
      <h5 style={h5textStyle}>{aboutUs.end}</h5>


    </Box>
  );
}

export default AboutUsPage;